// src/WelcomeScreen.js
import React, { useState, useEffect } from "react";

const WelcomeScreen = ({ onFinish }) => {
    const [typedText, setTypedText] = useState("");

    useEffect(() => {
        const message = "W elcome to A.P Tech Solution – Your Reliable Technology & Software Partner.";
        let currentIndex = 0;

        const typingInterval = setInterval(() => {
            if (currentIndex <= message.length - 1) {
                setTypedText(prev => prev + message.charAt(currentIndex));
                currentIndex++;
            }

            if (currentIndex === message.length) {
                clearInterval(typingInterval);
                setTimeout(() => {
                    onFinish(); // Jab typing khatam ho jaye
                }, 1500);
            }
        }, 70);

        return () => clearInterval(typingInterval);
    }, [onFinish]);

    return (
        <div className="unique-welcome-screen">
            <div className="unique-typing-text">{typedText}</div>
        </div>
    );
};

export default WelcomeScreen;
